import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge Tailwind CSS classes with clsx for conditional class handling */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getEditorTypeFromUrl(): string | null {
  if (typeof window === 'undefined') {return null;}
  const params = new URLSearchParams(window.location.search);
  return params.get('editor');
}

export function escapePostgresLike(text: string): string {
  if (!text) {return text as unknown as string;}
  return text
    .replaceAll('\\', '\\\\')
    .replaceAll('\'', "''")
    .replaceAll('%', '\\%')
    .replaceAll('_', '\\_')
    .replaceAll('(', '\\(')
    .replaceAll(')', '\\)')
    .replaceAll('[', '\\[')
    .replaceAll(']', '\\]')
    .replaceAll('+', '\\+')
    .replaceAll('*', '\\*')
    .replaceAll('?', '\\?')
    .replaceAll('.', '\\.')
    .replaceAll('^', '\\^')
    .replaceAll('$', '\\$')
    .replaceAll('|', '\\|');
}
